import { george, observer, pr, React, RouteComponentProps, theme, ui, debug } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { IchAppStore } from "./IchAppStore";
import { IchAppRoutes } from "./IchAppRoutes";

type IProps = RouteComponentProps<{}> & {
    store: IchAppStore;
};

@observer
export class IchAppDeregistrationSigning extends React.Component<IProps, {}> {
    render() {
        console.log("### signing");
        return (
            <SigningComponent
                useWebVersion
                pollingUrl={this.props.store.signingPollingUrl}
                authTransactionId={this.props.store.authTransactionId}
                content={
                    <>
                        <div style={{ padding: theme.MARGIN }}>
                            <george.SectionTitle style={{ marginTop: 0 }}>
                                {ui.__("common.summary")}
                            </george.SectionTitle>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <george.ResponsiveSummaryElement label={ui.__("signing.action.label")}>
                                <pr.SigningLabel>
                                    {ui.__("ichApp.deregistration.summary.action.description")}
                                </pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("common.fees")}>
                                <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <pr.SigningLabel style={{ marginTop: 32 }}>{ui.__("ichApp.deregistration.summary.text")}</pr.SigningLabel>
                        </div>
                    </>

                }
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute(IchAppRoutes.DEREGISTRATION_SUCCESS);
                }}
                onRetry={async () => {
                    await this.props.store.postAuthorization();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppDeregistrationSigning.tsx